angular
    .module("skillBuilderSaaS")
    .factory("catalogBannerService", ["catalogBannerResource", "_", CatalogBannerService]);
function CatalogBannerService(catalogBannerResource, _) {
    var catalogBannerServiceFactory = {
        data: {}
    };
    var getData = function () {
        if (catalogBannerServiceFactory.data.$resolved)
            return catalogBannerServiceFactory.data.$promise;
        else {
            var promise = catalogBannerResource.getEnabledCatalogBannerListView().$promise.then(function (result) {
                catalogBannerServiceFactory.data = result;
                return result;
            }).catch(angular.noop);
            return promise;
        }
    };
    var getForCategory = function (category, localizationId) {
        return _.where(catalogBannerServiceFactory.data.catalogBanners, { category: category, localizationId: localizationId });
    };
    catalogBannerServiceFactory.getData = getData;
    catalogBannerServiceFactory.getForCategory = getForCategory;
    return catalogBannerServiceFactory;
}
